import { AttachMoney } from '@mui/icons-material'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'
import { NavigateContext, M_Table, M_MessageBoard, M_Button, BufferService, LoadingContext, M_Fieldset } from 'src/M_Components'

export const InvoiceList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const location = useLocation()
    const { bookingId } = useParams()

    const [selectedLines, setSelectedLines] = useState([])

    const [totalWithoutVat, setTotalWithoutVat] = useState(0.0)
    const [totalWithVat, setTotalWithVat] = useState(0.0)

    const getCombinedFilter = () => {
        if (filter) return `BookingId eq ${filter}`
        return undefined
    }

    const [filter, setFilter] = useState()
    const [refresh, setRefresh] = useState(false)

    const onPassContext = (e) => {
        if (e) sessionStorage.setItem('context', JSON.stringify(e))
    }

    useEffect(() => {
        setTotalWithoutVat(selectedLines.reduce((previous, current) => previous + current.TotalWithoutVat, 0))
        setTotalWithVat(selectedLines.reduce((previous, current) => previous + current.TotalWithVat, 0))
    }, [selectedLines])

    useEffect(() => {
        setFilter(bookingId)
    }, [bookingId])

    useEffect(() => {
        setRefresh(true)
    }, [filter])

    const NewRoute = (url, label, operation, data) => {
        if (data) {
            ctx.passValue?.set('operation', operation)
            ctx.passValue?.set('row', data)
            ctx2.newTab(url, label)
        }
    }

    const NewFunctions = (type) => {
        const tempPerm = []
        const context = []
        const buttons = []

        roles.forEach((role) => {
            if (role.match('invoice')) {
                tempPerm.push(role.split('invoice')[1])
            }
        })

        if (tempPerm.includes('List')) {
            buttons.push({
                label: t("ViewInvoice"), element: 'default', source: '/icons/svgsDaNet/search.svg', style: { filter: "invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)" }, command: () => {
                    const data = JSON.parse(sessionStorage.getItem('lines'))
                    const row = Array.isArray(data) ? data[0] : data
                    NewRoute('go/invoiceDetail', t("ViewInvoice"), "View", row)
                }, needLine: true })
            context.push({ label: t("ViewInvoice"), icon: 'pi pi-search', command: () => {
                const row = JSON.parse(sessionStorage.getItem('context'))
                NewRoute('go/invoiceDetail', t("ViewInvoice"), "View", row)
            }, needLine: true })
        }
        // if (tempPerm.includes('DownloadPdf')) {
        //     buttons.push({ label: t("DownloadPdf"), element: 'default', source: '/icons/svgsDaNet/download.svg', style: { filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }, command: (e) => NewRoute('go/quoteRequest', t("DownloadPdf"), "Download", e) })
        //     context.push({ label: t("DownloadPdf"), icon: 'pi pi-plus', command: (e) => NewRoute('go/downloadInvoicePdf', t("DownloadPdf"), "Download", e) })
        // }

        if (type === 'Context') return context
        if (type === 'Buttons') return buttons
    }

    return (
        <M_Table
            entityName={'receivable'}
            rolePermissions={roles}
            tablesOrder={tablesOrder}
            onTablesOrderUpdate={onTablesOrderUpdate}
            pageUrl={'Receivables'}
            FILTER={getCombinedFilter()}
            removeContextItems={['Print', 'Create','Copy', 'Edit', 'Delete', 'View']}
            extraButtons={NewFunctions('Buttons')}
            lineContext={NewFunctions('Context')}
            extraTopFields={
                <div style={{marginBottom: "20px", display: "flex", flexWrap: "wrap"}}>
                    <div style={{ display: "flex", alignItems: "center", justifyItems: "", marginRight: "30px", marginLeft: "10px" }}>
                        <span style={{color: ctx.secondaryColor, margin: "3px"}}>{t("TotalWithVat")}:</span> <span style={{fontWeight: "normal", margin: "3px"}}>{totalWithVat} €</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyItems: "" }}>
                        <span style={{color: ctx.secondaryColor, margin: "3px"}}>{t("TotalWithoutVat")}:</span> <span style={{fontWeight: "normal"}}>{totalWithoutVat} €</span>
                    </div>
                </div>
            }
            onPassLine={(lines) => {
                setSelectedLines(lines)
                if (lines) sessionStorage.setItem('lines', JSON.stringify(lines))
            }}
            onPassContext={onPassContext}
            refresh={refresh}
            setRefresh={setRefresh}
        />
    )
}
